/**
 * @Author: Nemo
 * @Description: 表单字段排序
 * @Date: 2024-11-30
 * @FilePath: /rhcn-checkout-web/src/common/config/field-config/sort.js
 */

// 支付信息字段顺序
export const paymentFieldsOrder = [
  'cardNum',
  'effectiveDate',
  'cvv',
  'issueDate',
  'cardHolderName',
  'prepaidNumber',
  'identityNumber',
  'birthDate',
  'bankName',
  'iBan',
  'jpFirstName',
  'jpLastName',
  'blikcode', // blik支付方式独有
  'walletAccountName', // 本地支付用户名
  'periodValue', // 分期字段
];

// 账单地址字段顺序
export const billingFieldsOrder = [
  'country',
  'province',
  'address',
  'city',
  'postalCode',
  'email',
  'contactName', // 代表firstName和lastName
  'firstName',
  'lastName',
  'phone',
  'street',
  'number',
];

/**
 * 支付信息字段排序
 * @param {Array} fields 支付字段数组
 * @returns {Array} 排序后的字段数组
 */
export function paymentFieldsSort(fields) {
  if (fields && fields.length) {
    fields.sort((field1, field2) => paymentFieldsOrder.indexOf(field1.name) - paymentFieldsOrder.indexOf(field2.name));
  }
  return fields;
}

/**
 * 账单信息字段排序
 * @param {Array} fields 账单字段数组
 * @returns {Array} 排序后的字段数组
 */
export function billingFieldsSort(fields) {
  if (fields && fields.length) {
    fields.sort((field1, field2) => billingFieldsOrder.indexOf(field1.name) - billingFieldsOrder.indexOf(field2.name));
  }
  return fields;
}

/**
 * 根据表单类型进行排序
 * @param {string} formType 表单类型 'payment' 或 'billing'
 * @param {Array} fields 需要排序的字段数组
 * @returns {Array} 排序后的字段数组
 */
export function sortFieldsByType(formType, fields) {
  if (!fields || !fields.length) {
    return fields;
  }

  if (formType === 'payment') {
    return paymentFieldsSort(fields);
  } else if (formType === 'billing') {
    return billingFieldsSort(fields);
  }

  return fields;
}
